import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { ReactComponent as IconEditCircle } from "../Images/icon_edit_circle.svg";
import { ReactComponent as IconProfile } from "../Images/icon_profile.svg";
import { postFormData, postJson } from "../Utils/apiUtils";
import {
  clearDashboardLogoState,
  getCompanyProfile,
  getDashboardResolvedLogoSrc,
  getDashboardLogoState,
  setDashboardLogoUpdatedFlag,
  setUpdatedDashboardLogo,
} from "../Utils/sessionUtils.js";

const HeaderCorporation = () => {
  const { companyName: name, email } = getCompanyProfile();
  const { logo, updatedLogo, isLogoUpdated } = getDashboardLogoState();
  const navigate = useNavigate();
  const [logoSrc, setLogoSrc] = useState(() => getDashboardResolvedLogoSrc());

  // let active_member_cnt = "230,242";
  // let waiting_member_cnt = "5";
  // let point = "2000";

  const [isClicked, setIsClicked] = useState(false);
  const clickRef = useRef(null);

  const handleClick = () => {
    setIsClicked(!isClicked);
  };
  const handleClickOutside = (e) => {
    if (clickRef.current && !clickRef.current.contains(e.target)) {
      setIsClicked(false);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setLogoSrc(reader.result);
        setUpdatedDashboardLogo(reader.result);
      };
      reader.readAsDataURL(file);
      handleUpdateLogo(file);
    }
  };

  const handleUpdateLogo = async (selectedFile) => {
    try {
      const formData = new FormData();
      formData.append("image", selectedFile);

      const res = await postFormData("/company/updateLogo", formData, navigate);

      console.log(res);
      if (res.code === 200) {
        setDashboardLogoUpdatedFlag(true);
        window.location.reload("/company");
      }
    } catch (error) {
      console.log("로고 변경 중 에러");
      throw error;
    }
  };

  const handleDeleteLogo = async () => {
    try {
      const res = await postJson("/company/deleteLogo", {}, navigate);
      console.log(res);
      if (res.code === 200) {
        setLogoSrc(null);
        clearDashboardLogoState({ removeStoredLogo: true });
        window.location.reload("/company");
      }
    } catch (error) {
      console.log("로고 삭제 중 에러");
      throw error;
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setLogoSrc(getDashboardResolvedLogoSrc());
  }, [logo, updatedLogo, isLogoUpdated]);

  return (
    <div>
      <HeaderBox>
        <div>
          <div style={{ width: "120px", height: "120px" }}>
            {logoSrc ? (
              <img
                src={logoSrc}
                alt="company logo"
                style={{ width: "100%", height: "100%", borderRadius: "10px" }}
              />
            ) : (
              <IconProfile width="120px" height="120px" />
            )}
            <IconEditCircle
              style={{
                position: "absolute",
                marginLeft: "-34px",
                marginTop: "83px",
                cursor: "pointer",
                zIndex: 10,
              }}
              onClick={handleClick}
            />
          </div>

          {isClicked ? (
            <div
              className="editOrdelete_Box"
              style={{ width: "94px", marginLeft: "90px" }}
            >
              <div onChange={handleFileChange}>
                <input
                  type="file"
                  id="image-upload"
                  style={{ display: "none" }}
                  accept="image/*"
                />
                <label
                  htmlFor="image-upload"
                  className="editOrdelete_Btn edit center"
                  style={{ width: "94px" }}
                >
                  이미지 변경
                </label>
              </div>
              <div
                className="editOrdelete_Btn delete"
                style={{
                  width: "80px",
                  paddingLeft: "14px",
                  display: "flex",
                  alignItems: "center",
                  marginTop: "8px",
                  marginBottom: "0",
                }}
                onClick={() => {
                  handleDeleteLogo();
                  handleClick();
                }}
              >
                삭제
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
        <div style={{ marginLeft: "20px", marginTop: "25.5px" }}>
          <div className="nameTitle">{name}</div>
          <div style={{ fontSize: "18px", color: "#888888" }}>{email}</div>
        </div>
        {/* <div className="infoArea">
          <div>
            <div style={{ display: "flex" }}>
              <IconGroup fill="#1167ed" />
              <div className="infoTitle">활성 구성원</div>
            </div>
            <div className="infoData">{active_member_cnt}명</div>
          </div>
          <div>
            <div style={{ display: "flex" }}>
              <IconGroup fill="#F25C5C" />
              <div className="infoTitle">승인 대기</div>
            </div>
            <div className="infoData">{waiting_member_cnt}명</div>
          </div>
          <div>
            <div style={{ display: "flex" }}>
              <IconP />
              <div className="infoTitle">보유 포인트</div>
            </div>
            <div className="infoData">{point}P</div>
          </div>
        </div> */}
      </HeaderBox>
    </div>
  );
};

const HeaderBox = styled.div`
  width: auto;
  height: auto;
  padding: 30px 180px 30px 180px;
  overflow: hidden;
  background-color: #ffffff;
  display: flex;
  margin-top: 80px;
  .nameTitle {
    font-family: "notoSans-bold";
    font-size: 30px;
    color: #000000;
  }
  .infoArea {
    width: 480px;
    height: 63px;
    display: grid;
    grid-template-columns: 170px 170px 140px;
    margin-top: 57px;
    margin-left: auto;
    .infoTitle {
      font-family: "notoSans-medium";
      color: #222222;
    }
    .infoData {
      font-family: "notoSans-bold";
      font-size: 24px;
      color: #222222;
      margin-top: 4px;
    }
  }
`;

const NavButton = styled.div`
  font-family: "notoSans-bold";
  font-size: 24px;
  color: #222222;
  margin-top: 22px;
  margin-left: 194px;
`;

export default HeaderCorporation;
